import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FormatUtilsService {
  constructor() {}

  formatCep(value: string) {
    if (!value) {
      return value;
    }

    value = value.replace(/\D/g, '');
    value = value.substring(0, 8);

    if (value.length > 5) {
      value = `${value.substring(0, 5)}-${value.substring(5)}`;
    }
    return value;
  }

  formatPhone(value: string) {
    if (!value) {
      return value;
    }

    value = value.replace(/\D/g, '');

    if (value.length > 10) {
      value = value.substring(0, 10);
    }

    if (value.length > 6) {
      value = `(${value.substring(0, 2)}) ${value.substring(
        2,
        6
      )}-${value.substring(6)}`;
    } else if (value.length > 2) {
      value = `(${value.substring(0, 2)}) ${value.substring(2)}`;
    } else {
      value = value;
    }

    return value;
  }

  formatMobilePhone(value: string) {
    if (!value) {
      return value;
    }

    value = value.replace(/\D/g, '');

    if (value.length > 11) {
      value = value.substring(0, 11);
    }

    if (value.length > 6) {
      value = `(${value.substring(0, 2)}) ${value.substring(
        2,
        7
      )}-${value.substring(7)}`;
    } else if (value.length > 2) {
      value = `(${value.substring(0, 2)}) ${value.substring(2)}`;
    } else {
      value = value;
    }

    return value;
  }

  formatPhoneNumber(value: string) {
    if (!value) {
      return value;
    }

    // Remove all non-digit characters
    value = value.replace(/\D/g, '');

    // Restrict the input to a maximum of 11 digits
    if (value.length > 11) {
      value = value.substring(0, 11);
    }

    // Apply house phone mask for 10 digits
    if (value.length === 10) {
      value = `(${value.substring(0, 2)}) ${value.substring(
        2,
        6
      )}-${value.substring(6)}`;
    }
    // Apply mobile phone mask for 11 digits
    else if (value.length === 11) {
      value = `(${value.substring(0, 2)}) ${value.substring(
        2,
        7
      )}-${value.substring(7)}`;
    }
    // For partial input (less than 10 or 11 digits), apply basic formatting
    else if (value.length > 6) {
      value = `(${value.substring(0, 2)}) ${value.substring(
        2,
        7
      )}-${value.substring(7)}`;
    } else if (value.length > 2) {
      value = `(${value.substring(0, 2)}) ${value.substring(2)}`;
    }

    return value;
  }

  formatCpf(value: string) {
    if (!value) {
      return '-';
    }

    value = value.replace(/\D/g, '');
    const part1 = value.substring(0, 3);
    const part2 = value.substring(3, 6);
    const part3 = value.substring(6, 9);
    const part4 = value.substring(9, 11);

    return `${part1}${part2 ? '.' + part2 : ''}${part3 ? '.' + part3 : ''}${
      part4 ? '-' + part4 : ''
    }`;
  }

  formatCnpj(value: string) {
    if (!value) {
      return '-';
    }

    value = value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();

    const part1 = value.substring(0, 2);
    const part2 = value.substring(2, 5);
    const part3 = value.substring(5, 8);
    const part4 = value.substring(8, 12);
    const part5 = value.substring(12, 14);

    return `${part1}${part2 ? '.' + part2 : ''}${part3 ? '.' + part3 : ''}${
      part4 ? '/' + part4 : ''
    }${part5 ? '-' + part5 : ''}`;
  }
}
